import { render } from "./qrCodesDialog.vue?vue&type=template&id=54dc8f7c"
import script from "./qrCodesDialog.vue?vue&type=script&lang=js"
export * from "./qrCodesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__